import { ETF_OVERLAP_QUESTION } from "../constants/copy";

/** 协议行的 referenceType；与后端 `ReferenceType.ETF_OVERLAP`、KMP `ETF_OVERLAP_REFERENCE_TYPE` 逐字一致。 */
export const ETF_OVERLAP_REFERENCE_TYPE = "etf_overlap";

/**
 * 重叠分析的协议行：`[label](referenceType=etf_overlap)\n`，**正文为空**。
 *
 * 为什么必须空正文：后端对「协议行 + 空正文」走确定性短路（零 LLM 即时交付）；
 * 若带正文（如 `buildAdChatMessage` 的 `...)\n{问题原文}`）会落到 LLM 兜底路径。
 * 形态与 `buildPortfolioUploadHoldingsChatQuestion`（`portfolio_upload`）一致，**不要复用 `buildAdChatMessage`**。
 */
export const buildEtfOverlapChatMessage = (
  label: string = ETF_OVERLAP_QUESTION,
): string => {
  // label 可能来自后端配置的推荐问题标题：`[` `]` 与换行会破坏协议行（`isEtfOverlapReference` 的
  // 正则不认），先抹成空格；清完为空就回退共享文案，保证协议行始终可被后端 / 前端识别。
  const safeLabel = label
    .replace(/[[\]\r\n]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return `[${safeLabel || ETF_OVERLAP_QUESTION}](referenceType=${ETF_OVERLAP_REFERENCE_TYPE})\n`;
};

const ETF_OVERLAP_REFERENCE_PATTERN =
  /^\[[^\]\r\n]+\]\(referenceType=etf_overlap\)\s*$/;

/** 是否为重叠分析协议行（额度旁路、同步状态卡、结果标记的统一判断）。 */
export const isEtfOverlapReference = (question?: string | null): boolean =>
  ETF_OVERLAP_REFERENCE_PATTERN.test(question ?? "");
